import styled from 'styled-components';

import { screens } from 'ggApp/utils/mixins/screens';
import Logo from './images/logo.svg';

export const CheckoutFooter = styled.div`
    margin-top: 60px;
    padding: 0 30px;

    @media (${screens.phone}) and (${screens.desktopMax}) {
        display: none;
    }
`;

export const Wrap = styled.div`
    display: flex;
    align-items: center;
    padding-bottom: 30px;
    justify-content: space-between;
`;

export const TrustBadges = styled.div`
    display: flex;
`;

export const Copyright = styled.div`
    background-image: url(${Logo});
    background-position: 0 50%;
    background-repeat: no-repeat;
    background-size: 30px auto;
    padding-left: 35px;
    min-height: 20px;
    display: flex;
    align-items: center;
    margin-right: 60px;

    font-size: 12px;
    line-height: 1.35;

    a {
        color: #3d02ff;
        text-decoration: none;
    }

    a:hover,
    a:active,
    a:focus {
        color: #0099ff;
    }
`;
